<template>
    <v-row no-gutters justify="center" align="center" class="mx-5 mt-12">
        <v-col cols="12" md="6" align="center">
            <v-card class=" px-3" style="background: #232323;" dark>
                <v-row align="center" justify="center">
                    <v-col cols="12" align="center" class="pb-0 mb-0">
                        <img :width="!$vuetify.breakpoint.mobile ? '70px' : '70px'" contain :src="require('@/assets/contact-message-icon.svg')">
                    </v-col>
                    <v-col cols="12" align="center" class="pt-0 mt-0">
                        <span class="font-weight-bold text-h6">Στοιχεία Επικοινωνίας</span>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-col cols="12" align="center">
                        <div style="font-size: 40px;">EKA BASKET</div>
                        <!-- <div class="text-h6">ΑΘΛΗΤΙΚΕΣ ΔΡΑΣΤΗΡΙΟΤΗΤΕΣ</div>
                        <div class="text-h6">ΑΦΜ 802999726 – ΔΟΥ ΚΕΦΟΔΕ ΑΤΤΙΚΗΣ</div>
                        <div class="text-h6">ΓΕΜΗ 187097501000</div> -->
                    </v-col>
                </v-row>
                <v-row align="start">
                    <v-col cols="12" align="center" justify="center">
                        <v-divider
                            horizontal
                            color="teal"
                            class="custom-divider"
                            width="800px"
                        />
                    </v-col>
                </v-row>
                <!-- <v-row align="center" justify="center">
                    <v-col cols="12" align="center">
                        <div>
                            <span class="text-h6 custom-teal-text">Διεύθυνση: </span>
                            <a href="https://www.google.com/maps/place/Menelaou+15,+Iraklio+141+22/@38.051379,23.7545482,17z/data=!3m1!4b1!4m6!3m5!1s0x14a1a20c0ba09cd1:0x187851f32e362fae!8m2!3d38.0513748!4d23.7571231!16s%2Fg%2F11csgbr6vw?authuser=0&entry=ttu&g_ep=EgoyMDI1MTEwNC4xIKXMDSoASAFQAw%3D%3D" style="text-decoration: none; color: white;"><span class="text-subtitle-1">Μενελάου 15α 141 22 Ν. Ηράκλειο, Αττικής</span></a>
                        </div>
                        <div>
                            <span class="text-h6 custom-teal-text">Κινητό: </span>
                            <a href="tel:+306973317561" style="text-decoration: none; color: white;"><span class="text-subtitle-1">6973317561</span></a>
                        </div>
                        <div>
                            <span class="text-h6 custom-teal-text">Κινητό: </span>
                            <a href="tel:+306972901611" style="text-decoration: none; color: white;"><span class="text-subtitle-1">6972901611</span></a>
                        </div>
                        <div>
                            <span class="text-h6 custom-teal-text">Email: </span>
                            <a href="mailto:elias.alexiou@commercial-league.gr" style="text-decoration: none; color: white;"><span class="text-subtitle-1">elias.alexiou@commercial-league.gr</span></a>
                        </div>
                        <div>
                            <span class="text-h6 custom-teal-text">Email: </span>
                            <a href="mailto:i.mertyris@commercial-league.gr" style="text-decoration: none; color: white;"><span class="text-subtitle-1">i.mertyris@commercial-league.gr</span></a>
                        </div>
                    </v-col>
                </v-row> -->
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
        }
    }
</script>

<style scoped>
.custom-divider {
    border-width: 1px;
}
</style>
